module.exports = __webpack_public_path__ + "flyer_background_cupcake_two_038-229199d894269c91a6601cc903cdcb6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_cupcake_two_038.jpg
// module id = 1634
// module chunks = 1